module.exports = "<div class=\"subscriberdiv\" #subscriberDiv></div>\n<div *ngIf=\"messageErreur\">\n  <app-popin [titre]=\"TITRE_POPIN\" [messageError]=\"messageErreur\" [path]=\"PAGE_DOSSIER\"></app-popin>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/visio/subscriber/subscriber.component.html
// module id = ./src/app/visio/subscriber/subscriber.component.html
// module chunks = main